/**
 * Represents a comment.
 */
export class Comment {
    constructor(id, commentProperties, text) {
        this.id = id;
        this.commentProperties = commentProperties;
        this.text = text;
    }
}
